import { Modal } from '@studiometa/ui';

/**
 * VariantModal component
 */
export default class VariantModal extends Modal {
  /**
   * Component Configuration
   */
  static config = {
    name: 'VariantModal',
    ...Modal.config,
  };
}
